<template>
    <div class="rounded-md border border-solid border-black text-gray-700 w-full my-1 py-2 px-3 input-date">
        <datepicker
            :language="ptBR"
            :format="format"
            :clear-button="isClearButton"
            :disabled-dates="disabledDates"
            :clear-button-icon="clearButtonIcon"
            :calendar-button="isCalendarButton"
            :calendar-button-icon="calendarButtonIcon"
            v-model="selectedDate"
            @input="$emit('input', selectedDate)"
            name="operation_date">
        </datepicker>
        <slot name="description" />
    </div>
</template>

<script>
    import ptBR from 'vuejs-datepicker/dist/locale/translations/pt-BR.js';

    export default {
        props: {
            value: { type: [String, Date], default: '' },
            disabledDates: { type: Object, default: () => ({}) },
            isClearButton: { type: Boolean, default: true },
            clearButtonIcon: { type: String, default: 'fa fa-times text-gray-500 text-right' },
            isCalendarButton: { type: Boolean, default: false },
            calendarButtonIcon: { type: String, default: '' },
            format: { type: String, default: 'dd/MM/yyyy' }
        },
        data() {
            return {
                selectedDate: this.value,
                ptBR: ptBR
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

<style>
.input-date .vdp-datepicker__calendar-button{
    position: absolute;
    right: 15px;
}
</style>
